import React from 'react';
import { uuid } from 'uuidv4';

import '../App.css';

class AboutPage extends React.Component
{
	state = {
		experiences: [
			{
				role: "Game Developer & Designer",
				location: "Monstronauts",
				details:
					"July 2018 - August 2020\n\n" + 
					"I worked on implementing game features, creating visual effects, and creating ingame animations for Potion Punch 1 and Potion Punch 2 and one of their upcoming projects.",
				imageURL: "monstronauts2.jpg",
			},
			{
				role: "Internship",
				location: "Anino",
				details:
					"June - August 2017\n\n" + 
					"I worked on their project, Double Win Vegas: Slots. My tasks went from bug fixing to feature implementing and finally to helping in the creation of slot machines.",
				imageURL: "anino.jpg",
			},
			{
				role: "Game Developer & Designer",
				location: "Global Game Jam 2019",
				details:
					"January 2019\n\n" +
					"This game jam posed a challenge for our team as had to make a story game and code it within the limited time of a jam. " +
					"I contributed to the programming and the creation of the narrative of our game.",
				imageURL: "ggj2-2019.jpg",
			},
			{
				role: "Game Developer & Designer",
				location: "Global Game Jam 2018",
				details:
					"January 2018\n\n" + 
					"Our team made a game that focused on replayability. " +
					"I coded the main mechanics and the controls and helped in balancing the values of the game. " +
					"Our game was awarded as Judge's Choice and as one of the Top 5 games in the venue. " +
					"It was also featured with its own booth at Gamecon PH 2018.",
				imageURL: "ggj2-2018.jpg",
			},
			{
				role: "Game Developer & Designer",
				location: "Salinlahi 2017",
				details:
					"Decemeber 2017\n\n" +
					"The main objective of this contest was to create a game that showcases the contributions of Filipino scientists. " +
					"Our team's entry, Science League, contains 3 minigames that each have " +
					"something to do with a scientist's contribution and how it helps the agricultural scene. " +
					"Our team won 2nd place for this competition and was showcased with its own booth in a NAST event in July 2018.",
				imageURL: "salinlahi.jpg",
			},
			{
				role: "Game Developer",
				location: "Ateneo Blue Hacks 2016",
				details:
					"February 27-28 2016\n\n" +
					"Blue Hacks is a 24-hour hackathon where you make a program that revolves around a given theme. " +
					"The theme for this year's event was 'Student Life' and our team won 1st place with our entry, " +
					"Revise, a web app that integrates your notes with games to make studying fun again. " +
					"My contribution to Revise was the game design and programming for all the 3 games.",
				imageURL: "bh2016.jpg",
			},
			{
				role: "Game Developer",
				location: "Computer Society of the Ateneo",
				details:
					"September 2017 - April 2018\n\n" +
					"I was only active in the organization in my last year of college. " +
					"I held a tutorial for the other members who wanted to try out game development and I also took on my first freelance gig with a fellow student.",
				imageURL: "compsat2.jpg",
			},
			{
				role: "Programmer",
				location: "Others",
				details:
					"2014 - Present\n\n" +
					"I still have personal projects from time to time. " +
					"My latest one is currently named Butterpond's Hero. " +
					"It's a roguelike game with a narrative that will hopefully capture the hearts of the players.\n\n" +
					"I also do coding challenges on my twitch stream where I try to recreate hypercasual mobile games within 3 hours.",
				imageURL: "laptop.jpg",
			}
		]
	}
	
	renderGallery = () =>
	{
		var divs = [];

		var images = [
			"ggj.jpg",
			"thesis.jpg",
			"random.jpg",
		]

		for (var i = 0; i < images.length; i++)
		{
			divs.push(
				<div key={uuid()} className='about-intro-image-container'>

					<img className='about-intro-image' src={require("../images/about/gallery/" + images[i])} />

				</div>
			)
		}

		return (

			<React.Fragment>
				{divs}
			</React.Fragment>

		);
	}

	renderExperiences = () =>
	{
		var detailsShownStyle = {
			...detailsBaseStyle,
			height: "auto"
		};

		var detailsHideStyle = {
			...detailsBaseStyle,
			height: "0"
		};

		return (
			<React.Fragment>

				{this.state.experiences.map((value) => (
					
					<div
						key={uuid()}
						className='about-experience-container'
						>
						                 
						<input className='about-experience-toggle' type="checkbox" />

						<div className='about-experience-contents'>

							<div className='about-experience-banner'>

								<img className='about-experience-img' src={require("../images/about/experiences/" + value.imageURL)} />

								<div className='about-experience-arrow'> &#709; </div>

								<div className='about-experience-banner-contents' style={{ zIndex: "1" }}>

									<div className='about-experience-role'> {value.location} </div>
									<div className='about-experience-location'> {value.role} </div>

								</div>

							</div>

							<div
								className='about-experience-details-container'
							>

								<p className='about-experience-details'>
									{value.details}
								</p>

							</div>

						</div>

					</div>
				))}

			</React.Fragment>
		);
	}

	render()
	{
		const description =
			"Greetings! I'm Tup Luisking and I'm a game developer from the Philippines." +
			"I graduated from the Ateneo De Manila University with a degree in Computer Science.\n\n" + 
			"I love making games as much as I love playing them. " +
			"It takes me a while to overcome my shyness and get comfortable in a new environment but you best bet that I won't let that get in the way of me doing my job.\n\n" + 
			"I didn't have a clear career path in mind when I started college but on my second year, " +
			"a friend introduced me to the Unity game engine and since then I started forming my path as a game developer.";
		
		const education =
			"I find comfort in thinking that my career as a game developer is still just beginning as I have a lot to learn from the collective experiences of everyone else in the game industry.\n\n" +
			"Learning new things even beyond programming in games is always a pleasure. " +
			"I've tried to dabble in making 2D and 3D assets and I want to learn how to market a game properly as well. " +
			"I want to use these new learnings to have a greater contribution to the success of a game";

		return (

			<div className='page about-page'>

				<div className='section about-intro-section'>

					<div
						className='about-intro-start'
					>

						<div className='about-intro-portrait-container'>

							<div className='about-intro-portrait'>

							</div>

						</div>

						<div className='about-intro-description-container'>

							<div className='section-header about-section-header'>

								About Me
	
						</div>

							<div className='about-intro-description'>

								{description}

							</div>

						</div>

					</div>

					<div className='about-intro-education-container'>

						{education}

					</div>

					<div className='about-intro-gallery'>

						{this.renderGallery()}

					</div>

				</div>

				<div className='section about-experience-section'>

					<div className='section-header'>

						Experience

					</div>

					{this.renderExperiences()}

				</div>

			</div>

		);
	}
}

const detailsBaseStyle = {

	overflow: "hidden",
	height: "0",

	transitionDuration: "1s",
	transitionProperty: "all"
}

export default AboutPage;